import { PropsWithChildren } from 'react';
import { Box, Link, SxProps, Theme, Typography } from '@mui/material';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';

/**
 * A React component that renders an external link with an icon indicating it opens in a new tab.
 *
 * @param children - The content to be displayed inside the link.
 * @param href - The URL for the link. If not provided, the link will not be clickable.
 * @param sx - Optional styling properties to customize the appearance of the link.
 */
const ExternalLink = ({
    children,
    href,
    sx,
}: PropsWithChildren<{
    /** URL for the link */
    href?: string;
    sx?: SxProps<Theme>;
}>) => {
    return (
        <Box display="inline-flex" component="span">
            <Typography component="span" noWrap>
                <Link
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={sx}
                >
                    {children}

                    <Box
                        display="inline-flex"
                        alignItems="center"
                        ml={0.3}
                        sx={{ verticalAlign: 'middle' }}
                    >
                        <OpenInNewRoundedIcon fontSize="small" />
                    </Box>
                </Link>
            </Typography>
        </Box>
    );
};

export default ExternalLink;
